const messages = {
  es: {
    message: {
      home: {
        menu: {
          tasas: {
            titulo: 'Tasa | Tasas',
            detalle: 'Presentacíon, consulta y pago de tasas {tipo}'
          },
          cuotas: {
            titulo: 'Cuota | Cuotas',
            detalle: 'Presentacíon y consulta de cuotas {tipo}'
          },
          entidades: {
            titulo: 'Entidad Financiera | Entidades Financieras',
            detalle: 'Obtención del justificante de ingreso NRC'
          }
        }
      },
      login: {
        titulo: 'Tasas y Declaraciones',
        sinEmpresa:
          '<p>No tiene acceso a la Tramitación de ingresos de tasas y cuotas.</p><p>Si desea acceso puede solicitarlo por correo electrónico en <span class="negrita">gestion.sedeelectronica@cnmc.es</span>.</p>',
        sinAcceso:
          '<p><span class="negrita">No se ha podido iniciar sesión. </span></p><p>Es necesario un certificado digital de representación de persona jurídica válido y estar dado de alta en la aplicación</p><p>Por favor, cierre el navegador web y vuelva a intentarlo.</p><p>Si desea dirigirse a la Unidad de gestión económica para realizar alguna consulta utilice la dirección de email siguiente: <span class="negrita">de.gestioneconomica@cnmc.es </span></p>'
      },
      tasas: {
        menu: {
          presentar: {
            titulo: 'Presentar Tasa',
            detalle: 'Formulario de presentación de declaraciones de tasa '
          },
          consultarDeclaraciones: {
            titulo: 'Consultar Tasas Presentadas',
            detalle: 'Consulta de declaraciones de {tipo}'
          },
          pagar: {
            titulo: 'Pagar Tasa',
            detalle: 'Formulario de pago en AEAT'
          },
          consultarPagos: {
            titulo: 'Consultar Pagos de Tasas',
            detalle: 'Consulta de pagos en AEAT'
          }
        },
        tituloE:
          'Tasa aplicable a la prestación de servicios y realización de actividades por la CNMC en relación con el sector eléctrico: Código 306',
        tituloG:
          'Tasa aplicable a la prestación de servicios y realización de actividades por la CNMC en relación con el sector hidrocarburos gaseosos: Código 307',
        tituloP:
          'Tasa aplicable a la prestación de servicios y realización de actividades por la CNMC en relación con el sector de hidrocarburos líquidos: Código 311',
        instrucciones: 'INSTRUCCIONES PARA LA CUMPLIMENTACIÓN DE TASA {tipo}',
        apartado1: 'I. PERIODO DE DECLARACIÓN',
        apartado2: 'II. BASE IMPONIBLE TARIFA',
        apartado3: 'III. BASE IMPONIBLE PEAJE',
        apartado4: 'IV. LIQUIDACIÓN TASA',
        apartado5: 'DECLARANTE',
        apartado6: 'INGRESO',
        presentarTasa: 'Presentar TASA. Modelo 791',
        presentarTasaAviso: 'Se va a proceder a presentar la declaración.',
        pagarTasa: 'Pagar TASA',
        consultarTasa: 'Consultar TASA. Modelo 791',
        periodo: {
          nombre: 'Nombre',
          nombreTARIFAE: 'Suministro',
          nombrePEAJEE: 'Suministro',
          nombreTARIFAG: 'Producto',
          nombrePEAJEG: 'Suministro',
          periodo: 'Periodo',
          facturacion: 'Facturación - Base Imponible',
          baseImponible: 'Base Imponible | Base Imponible (€)',
          actions: 'Acciones'
        },
        liquidacion: {
          tipo: 'Tipo(%)',
          cuotaTributaria: 'Cuota Tributaria (€)',
          total: 'Total a ingresar',
          pepe: 'pepe'
        }
      },
      cuotas: {
        tipo: {
          10: {
            titulo: 'COMPENSACIÓN INSULARES Y EXTRAPENINSULARES'
          },
          20: {
            titulo: 'OPERADOR DEL SISTEMA'
          },
          30: {
            titulo: 'OPERADOR DEL MERCADO'
          },
          80: {
            titulo:
              'COSTES DE LA COMPENSACIÓN POR INTERRUMPIBILIDAD, POR ADQUISICIÓN DE ENERGÍA A LAS INSTALACIONES DE  PRODUCCIÓN EN RÉGIMEN ESPECIAL Y OTRAS COMPENSACIONES'
          },
          85: {
            titulo:
              'RECARGO PARA RECUPERAR EL DÉFICIT DE INGRESOS EN LA LIQUIDACIÓN DE LAS ACTIVIDADES REGULADAS GENERADO ENTRE EL 1 DE ENERO DE 2005 Y EL 31 DE DICIEMBRE DE 2005'
          },
          90: {
            titulo: 'MORATORIA NUCLEAR'
          },
          110: {
            titulo: 'CUOTA GESTOR TECNICO DEL SISTEMA'
          }
        },
        menu: {
          presentar: {
            titulo: 'Presentar Cuota',
            detalle: 'Formulario de presentación de declaraciones de cuotas {tipo}'
          },
          consultar: {
            titulo: 'Consultar Cuotas Presentadas',
            detalle: 'Consulta de declaraciones de cuotas {tipo}'
          }
        },
        tituloG:
          'DECLARACION DE INGRESOS CORRESPONDIENTES  AL GESTOR TECNICO DEL SISTEMA CON CARGO  A TARIFAS, PEAJES Y CANONES  EN EL SECTOR DE COMBUSTIBLES GASEOSOS',
        tituloE: 'DECLARACION DE INGRESOS DEL SECTOR ELECTRICO',
        instrucciones: 'INSTRUCCIONES PARA LA CUMPLIMENTACIÓN DE LA DECLARACIÓN DE CUOTA ELECTRICA',
        gas: {
          apartados1: 'PERIODO DE DECLARACION',
          apartados2: 'CUOTA SOBRE FACTURACION DE LAS TARIFAS DE SUMINISTRO DE GAS NATURAL',
          apartados3: 'CUOTA SOBRE FACTURACION DE PEAJES Y CANONES',
          apartados4: 'RESUMEN'
        },
        elec: {
          tabs: {
            caratula: 'Caratula',
            costesPermanentes: 'Costes Permanentes',
            costesDiv: 'Costes Div. Y Seguridad'
          },
          apartados1: 'PERIODO DE DECLARACION',
          apartados2: 'BASE DE COTIZACION TARIFA',
          apartados3: 'BASE DE COTIZACION PEAJE',
          apartados4: 'RESUMEN',
          base: {
            1: 'Tarifa',
            2: 'Peaje'
          }
        },
        periodo: {
          periodo: 'Periodo',
          facturacion: 'Facturación | Facturación (€)',
          nukwhfac: 'kWh Facturados',
          tipo: 'Cuota | Cuota (%)',
          base: 'Base de Cotización' || 'Base de Cotización (€)',
          tipoBase: 'Tipo de Base de Cotización',
          cuotaTributaria: 'Importe cuota | Importe cuota (€)',
          actions: 'Acciones',
          anadir1: 'Añadir periodo Tarifa anterior a 2010',
          anadir2: 'Añadir periodo Peaje',
          anadir4: 'Añadir periodo Tarifa',
          anadir7: 'Añadir periodo Peaje',
          modificar1: 'Modificar periodo Tarifa anterior a 2010',
          modificar2: 'Modificar periodo Peaje',
          modificar4: 'Modificar periodo Tarifa',
          modificar7: 'Modificar periodo Peaje',
          eliminar: 'Eliminar Periodo',
          sinPeriodos: 'No se han incluido periodos',
          alerta:
            '<p class="negrita">Has seleccionado marzo, en este mes hay dos tipos de cuota a aplicar, hasta el 6 de marzo, 0,8 % y desde el 7 de marzo 0,785 %. Selecciona la fecha correspondiente para que se aplique el tipo correcto.</p><p class="negrita">Para cualquier duda póngase en contacto con la unidad de Gestión Económica de.gestioneconomica@cnmc.es<p>',
          alerta2:
            '<p class="negrita">Según se establece en el apartado segundo de la Resolución de 17 de diciembre de 2020, de la Comisión Nacional de los Mercados y de la Competencia, por la que se establece la cuantía de retribución del gestor técnico del sistema para 2021 y la cuota para su financiación: “la cuota para la financiación de la retribución del gestor técnico del sistema en 2021 será del 0,966 por ciento”<p>',
          alerta85:
            '<p class="negrita">Según establece la Disposición Transitoria Segunda, de la Orden TED/1271/2020, de 22 de diciembre, “A partir del 1 de enero de 2021, el recargo para recuperar el déficit de ingresos de las actividades reguladas del ejercicio 2005 , será nulo”<p>'
        },
        resumen: {
          totalCuota: 'Total cuota',
          iva: 'I.V.A./I.G.I.C. ({importe}%)',
          totalIngreso: 'Total a Ingresar',
          textoIngresar: 'A ingresar en: ',
          textoTitular: 'Titular de la cuenta: ',
          textoCuenta: 'IBAN: '
        },
        presentarCuota: 'Presentar Declaración'
      },
      empresa: {
        tipos: 'ELECTRICIDAD | GAS',
        nombre: 'Empresa:',
        cif: 'CIF:',
        tipo: 'Tipo:',
        direccion: 'Dirección:'
      },
      comun: {
        mesDeclaracion: 'Mes declaración',
        mesFacturacion: 'Mes facturación',
        mesPerido: 'Mes periodo',
        fechaNotificacion: 'Fecha notificación',
        nif: 'NIF/CIF',
        nombre: 'Nombre',
        fecha: 'Fecha',
        ingreso:
          'Ingreso efectuado a favor del Tesoro Público, cuenta restringida de la A.E.A.T. para  la Recaudación de {tipo}.',
        consultaingreso:
          'Consulta de ingreso efectuado a favor del Tesoro Público, cuenta restringida de la A.E.A.T. para  la Recaudación de {tipo}.',
        importeTotal: 'Importe en euros',
        formaPago: 'Forma de pago',
        infoFechaActualizacionWeco:
          'Este listado es actualizado cada 6 horas. Fecha última actualización: {fecha}. En el caso de no encontrar una tasa, por favor inténtelo pasado unas horas.',
        formaPagos: {
          efectivo: 'En Efectivo',
          cuenta: 'E.C. Adeudo en cuenta'
        },
        cuenta: 'Código cuenta cliente (IBAN)',
        justificante: {
          numero: 'Nº Justificante',
          numeroValor: 'Nº Justificante: {valor}',
          tooltipNumero: 'Descargar declaración',
          codigoRegistro: 'Código Registro telemático',
          tooltipRegistro: 'Descargar justificante del registro',
          titulo: 'Declaración presentada correctamente',
          texto:
            'La declaración se ha registrado en el sistema correctamente con el código de registro telemático <span class="negrita">{cdregist}</span> y número de justificante <span class="negrita">{nujustas}</span>.',
          enProceso:
            'La declaración se ha registrado correctamente en el sistema. Cuando termine de procesarse podrá consultar el código de registro telemático y número de justificante, así como descargar este último en Inicio -> Tasas -> Consulta Tasas',
          enProcesoToolTip:
            'Procesando declaración. En unos minutos tendrá disponibles los documentos'
        },
        presentarDeclaracion: {
          tooltipRegistro: 'Presentar Tasa'
        },
        consultarDeclaracion: {
          tooltipRegistro: 'Consultar Tasa'
        },
        fechaPresentacion: 'Fecha Presentación',
        textoBusqueda:
          'Buscar declaración por cualquier campo de la tabla: Nº justificante, mes de declaración etc ...',
        sinDeclaracion: 'No se han encontrado declaraciones',
        sinResultadosBusqueda: 'No hay ninguna declaracion para el filtro de busqueda indicado',
        infoVisualizacion:
          'En esta vista únicamente se visualizarán las declaraciones presentadas telemáticamente desde el 03/04/2019',
        guardar: 'Guardar',
        cancelar: 'Cancelar'
      },
      footer: {
        copyright: 'Copyright © CNMC {anio}. Todos los derechos reservados',
        avisolegal: 'Aviso Legal y Política de Protección',
        contacto: 'Contacto',
        contactoText:
          'Si desea dirigirse a la Unidad de gestión económica para realizar alguna consulta sobre la aplicación utilice la dirección de email siguiente:',
        correo: 'de.gestioneconomica@cnmc.es'
      },
      errores: {
        401: {
          codigo: '401',
          detalle: 'Certificado digital con credenciales erróneas.'
        },
        403: {
          codigo: '403',
          detalle: 'Acceso no permitido al recurso.'
        },
        404: {
          codigo: '404',
          detalle: 'Página no encontrada.'
        },
        error: {
          titulo: 'Se ha producido un error en la aplicación',
          volver: 'Ir a Inicio'
        },
        redireccion: 'Se redireccionará a la página de inicio..',
        generico:
          'Por problemas técnicos no se puede realizar la petición deseada en estos momentos. Por favor inténtelo más tarde.',
        tipoNoPermitido: 'Tipo de empresa no permitido',
        tasaNoPermitida: 'A esta empresa no se le aplica esta tasa'
      },
      aeat: {
        detalleOK: 'Obtención del justificante de ingreso NRC',
        detalleError: 'Error al obtener el justificante de ingreso NRC',
        volver: 'Volver',
        return: {
          RET00: 'Operación finalizada OK',
          RET01: 'Número de justificante o importe erróneo o ausente',
          RET02: 'Modelo o tipo de operación no soportado',
          RET03: 'Solicitud anulada',
          RET04:
            'El certificado firmante no está autorizado para realizar el pago por personas ajenas',
          RET05:
            'El representante del certificado firmante no está autorizado para realizar el pago por personas ajenas',
          RET06: 'El certificado firmante no está autorizado para pagar y presentar este modelo',
          RET07: 'El certificado firmante no está autorizado para realizar este pago por convenio',
          RET08: 'La entidad emisora de esta tarjeta no admite este tipo de servicio',
          RET10: 'Concepto o modelo erróneo',
          RET11: 'Falta concepto o modelo',
          RET12: 'Ejercicio fiscal erróneo',
          RET13: 'Falta ejercicio fiscal',
          RET14: 'Período erróneo',
          RET15: 'Falta período',
          RET16: 'Tipo de moneda erróneo (distinto de E)',
          RET17: 'NIF / CIFincorrecto para este modelo',
          RET18: 'Falta tipo de moneda',
          RET19: 'Importe ingreso erróneo',
          RET20: 'Falta importe de ingreso',
          RET21: 'NIF y/o apellidos y nombre erróneos',
          RET22: 'Falta NIFdel contribuyente',
          RET23: 'NIFdel primer representante erróneo',
          RET24: 'Falta NIFdel representante',
          RET25: 'Sobra NIFdel representante',
          RET26: 'Falta nombre del contribuyente',
          RET27: 'Falta nombre del representante',
          RET28: 'Sobra nombre del representante',
          RET29: 'Código administración erróneo',
          RET30: 'Falta código administración',
          RET31: 'Anagrama erróneo',
          RET32: 'Falta anagrama',
          RET33: 'Sobra anagrama',
          RET34: 'Importe total y parcial no cuadra',
          RET35: 'Falta importe total',
          RET36: 'Sobra importe total',
          RET37: 'Opción fraccionamiento errónea',
          RET38: 'Falta opción fraccionamiento',
          RET39: 'CCC(Código Cuenta Cliente) erróneo',
          RET40: 'Falta CCC(Código Cuenta Cliente)',
          RET41: 'Importe redenominación erróneo',
          RET42: 'Falta importe redenominación',
          RET43: 'Tipo de operación erróneo',
          RET44: 'Falta tipo de operación',
          RET45: 'Tipo de petición erróneo (distinto de 01 o 02)',
          RET46: 'Falta tipo de petición',
          RET47: 'Tipo de autoliquidación erróneo (distinto de I o D)',
          RET48: 'Falta tipo de autoliquidación',
          RET49: 'NIFdel segundo representante erróneo',
          RET50: 'Concepto o modelo no permitidos',
          RET51: 'Ejercicio fiscal no permitido',
          RET52: 'Período no permitido',
          RET53: 'Ingreso no fraccionable por estar fuera del período voluntario',
          RET54: 'Ingreso fuera de período',
          RET55: 'Movimiento distinto de 01 y 02',
          RET56: 'El NIF del certificado firmante no figura como titular de la cuenta',
          RET57: 'NIF primer certificado distinto a NIFtecleado',
          RET58: 'NIF segundo certificado distinto a NIFtecleado',
          RET59: 'El horario de servicio es desde las 2:00 horas hasta las 23:00 horas diariamente',
          RET60: 'Fecha de presentación fuera de plazo',
          RET61: 'Importe total de la deuda erróneo',
          RET62: 'Autoridad certificadora errónea',
          RET63: 'Certificado caducado',
          RET64: 'Certificado revocado',
          RET65: 'Presentador no autorizado en nombre de terceras personas',
          RET66: 'Ha firmado 2 veces con el mismo representante',
          RET67: 'Período impositivo / concluido erróneo',
          RET68: 'Fecha de conclusión período impositivo errónea',
          RET69: 'Error de formato en los datos de la petición',
          RET70: 'Petición duplicada. Utilice la opción de consulta',
          RET71: 'No existe cargo con los datos consultados',
          RET72: 'Código de cuenta (IBAN) cancelado',
          RET73: 'Código de cuenta (IBAN) bloqueado (judicialmente)',
          RET74: 'Código de cuenta (IBAN) con saldo no disponible',
          RET75: 'Código de cuenta (IBAN) con saldo insuficiente',
          RET76: 'Código de cuenta (IBAN) - Cuenta no es de ahorro a la vista',
          RET77: 'Código de cuenta (IBAN) inexistente',
          RET78: 'Código de cuenta (IBAN) inoperante',
          RET79: 'NIF delfirmante no titular a la cuenta',
          RET80: 'NIF representante no apoderado de la cuenta',
          RET81: 'Firmante no persona jurídica (e informa representante)',
          RET82: 'Falta segundo NIF por ser cuenta conjunta',
          RET83: 'El segundo NIF no corresponde a titular de la cuenta',
          RET84: 'MAC erróneo',
          RET85: 'No hay suficientes apoderados',
          RET86:
            'Esta entidad no atiende la solicitud de cargo por esta vía en este rango horario (y se le añade opcionalmente explicación de horario de servicio que puede venir en la cadena de respuesta desde la posición 211 hastala 400)',
          RET87:
            'Texto de la Entidad Colaboradora en la cadena de respuesta desde la posición 211 hasta la 400 con teléfono de atención al cliente obligatoriamente, y ,si cabe, explicación amplia sobre la incidencia.',
          RET88: 'Contribuyente no identificado',
          RET89: 'Fecha de validez/caducidad de la tarjeta excedida, errónea o ausente',
          RET90: 'No está autorizado para realizar el pago por personas ajenas',
          RET91: 'Número de tarjeta no válido, erróneo o ausente',
          RET92: 'El titular del certificado con que se ha firmado no es titular de la tarjeta',
          RET93: 'Se ha excedido el límite de la operación',
          RET94: 'Tipo de tarjeta no soportado',
          RET95: 'Sólo se aceptan tarjetas emitidas por la propia entidad',
          RET96: 'NIF del obligado no titular a la cuenta',
          RET97: 'Error de comunicación con la EE.FF',
          RET98: 'Error de comunicación con la EE.FF',
          RET99: 'Error técnico',
          RETJK:
            'La Cl@ve PIN utilizada en la autenticación es distinta a la utilizada en la firma',
          RETJL:
            'Sólo puede ordenar pagos con Cl@ve PIN el propio obligado al pago (el contribuyente)',
          RETJM: 'El sistema Cl@ve PIN no admite pago con apoderamiento',
          RETJN: 'EL pago con Cl@ve PIN no está disponible para este modelo/operación/fecha',
          RETJO: 'Error técnico en el sistema Cl@ve PIN',
          RETJP:
            'Error en la firma. Su NIF está bloqueado en el sistema Cl@ve PIN por superar el número máximo diario de intentos de uso con un PIN incorrecto',
          RETJR: 'Error en la firma. PIN caducado',
          RETJS: 'Error en la firma. Su equipo está bloqueado en el sistema Cl@ve PIN',
          RETJV: 'Error en la firma. Revise el código de acceso introducido',
          RETJW: 'Error en la firma. No hay datos para la firma o no son válidos',
          RETJX:
            'Error en la firma. Su PIN ha sido bloqueado por superar el número máximo de intentos de uso con un PIN incorrecto. Debe obtener un nuevo PIN',
          RETP1:
            'Ha firmado con un certificado no válido para realizar firmas electrónicas. Si ha utilizado un DNI electrónico, ha firmado con el certificado de Autenticación y debe firmar con el certificado de Firma',
          RETP2: 'Certificado caducado y revocado',
          RETX1:
            'Servicio de pago de tasas obsoleto. El Departamento Ministerial u Organismo gestor de la tasa que usted desea pagar debe adaptar sus aplicaciones para utilizar la nueva pasarela de pago de tasas de la AEAT a la que se hace referencia en la Resolución de 4 de abril de 2017, de la Dirección General de la Agencia Estatal de Administración Tributaria',
          RETT8: 'Certificado no es de Empleado Público Autorizado',
          RETY1: 'Tipo de autenticación erróneo',
          RETY2:
            'El tipo de autenticacion debe ser 3 si el nro de soporte del DNI/NIE y/o el tipo de documento del ordenante de la operación tienen contenido',
          RETY3: 'El tipo de autenticacion debe ser 3 si variables empleado público con contenido',
          RETY4: 'Variables empleado público deben tener contenido para tipo de autenticación 3',
          RETY5:
            'Número de soporte obligatorio si tipo de documento del ordenante de la operación con contenido TEX, PRE o CRU',
          RETY6: 'Número de soporte erróneo: 00000000 o no numérico',
          RETY7:
            'Número soporte erróneo: debe empezar por C o E si tipo de documento del ordenante del pago es TEX o PRE',
          RETY8: 'Número soporte erróneo: para DNI debe ser 3 letras + 6 digitos',
          RETY9: 'Tipo de documento del ordenante del pago erróneo',
          RETYA:
            'Tipo documento del ordenante del pago debe tener contenido para tipo de autenticación 3',
          RETYB: 'NIF del empleado público erróneo',
          RETYC:
            'NIF del obligado al pago, NIF del ordenante del pago, NIF del primer representante y NIF del segundo representante deben ser distintos al NIF del empleado público',
          RETYD: 'NIF del ordenante del pago erróneo',
          RETYE: 'Pago con Cl@avePIN y representantes tienen contenido',
          RETYF: 'Pago con Cl@avePIN y ordenante del pago es persona jurídica',
          RETYG: 'Error en la URL de respuesta al Organismo',
          RETYH: 'Error de respuesta en link ADEJJAVB',
          RETYI: 'Número de soporte erróneo SVDI',
          RETYJ: 'Error en rutina ADEJJAVB',
          RETYK:
            'Anexo con marca distinta de Empleado Público y el certificado es de Empleado Público',
          RETYL: 'Empleado público no autorizado al servicio',
          RETYM: 'Operación no disponible para la entidad',
          RETA4: 'NRCno existe',
          RETA6: 'NIFno existe',
          RETA7: 'NRCya constituido. Inténtelo por consulta',
          RETA8: 'NRCno preconstituido. Inténtelo por consulta',
          RETA9: 'NRCya existe',
          RETB6: 'NRCno disponible para devolución',
          RETB8: 'NRCya liberado',
          RETC1: 'Incoherencia de datos',
          RETC2: 'NRCde operación ya existe',
          RETF2: 'NRCno disponible para devolución, ya devuelto',
          RETH4: 'Imposible cobro, NRCya cobrado',
          RETI3: 'Dígito de control erróneo.',
          RETI4: 'Carácter de control erróneo.',
          RETI6: 'Error en el modelo de operación.',
          RETI7: 'Error en el código del Banco de España.',
          RETI8: 'El depósito consultado no ha sido liberado.00=Operación finalizada OK'
        }
      }
    }
  }
};
export default messages;
